import styled from "styled-components";

export const TitleFaturaTextValue = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 50%;

  @media print {
    font-size: 9pt;
  }
`;

export const DateFaturaTextValue = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 50%;
  display: flex;
  justify-content: flex-end;

  @media print {
    font-size: 8pt;
  }
`;

export const SpanTextTitleBold = styled.span`
  color: #000;
  font-weight: bold;
  font-size: 14px;

  @media print {
    font-size: 8pt;
  }
`;

export const SpanTextTitle = styled.span`
  color: #000;
  font-size: 14px;

  @media print {
    font-size: 9pt;
  }
`;

export const Dividers = styled.hr`
  border-top: 3px dashed #7c7c7c;
  width: 100%;
  height: 1px;

  @media print {
    border-top: 1px solid #000;
  }
`;

export const SpanTextValue = styled.span`
  color: #000;
  font-size: 12px;
  font-weight: 600;
  width: 50px;

  @media print {
    font-size: 7pt;
  }
`;

export const SpanTextTitleDataBold = styled.span`
  color: #707070;
  font-weight: bold;
  font-size: 13px;
  margin-left: 1%;

  @media print {
    margin-left: 0;
    color: #000;
    font-size: 7pt;
  }
`;

export const SpanTextValueTitlePayment = styled.span`
  color: #1feb52;
  font-size: 12px;
  margin-left: 3%;
  width: 100%;

  @media print {
    font-size: 8pt;
    width: 350px;
    margin-left: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #000;
  }
`;

export const SpanTextValuePayment = styled.span`
  color: #1feb52;
  font-size: 12px;
  font-weight: 600;
  width: 50px;

  @media print {
    font-size: 7pt;
    color: #000;
  }
`;

export const SpanTextValueTitle = styled.span`
  color: #000;
  font-size: 12px;
  margin-left: 3%;
  width: 100%;

  @media print {
    font-size: 8pt;
    width: 350px;
    margin-left: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;